module.exports = [{
      plugin: require('/builds/mango-ins/landing-front/node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"#794CFA","showSpinner":true},
    },{
      plugin: require('/builds/mango-ins/landing-front/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
